var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-consultations',{attrs:{"consultations":_vm.consultations,"headers":_vm.headers,"loading":_vm.loading,"page":_vm.current_page,"page-count":_vm.last_page,"items-per-page":_vm.per_page},on:{"pagination":_vm.getConsultations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }